<template>
  <div>
    <b-row>
      <b-col
        lg="3"
        md="12"
      >
        <b-card-code
          :title="projectName"
          class="main styled"
        >
          <p><i>{{ projectDescription }}</i></p>
          <p class="list">
            <span class="tag"><feather-icon icon="UserIcon" /> Owner</span>  {{ projectOwner }}
          </p>
          <p class="list">
            <span class="tag"><feather-icon icon="UsersIcon" /> Visibility</span> {{ projectVisibility }}
          </p>
          <vue-scroll
            v-if="hasPipeline && hasServer && master && dependent"
            max-height="500px"
          >

          
            <progress-tasks
              :progress="progress"
              :computing="computingIndex"
              :disabled="computing"
            />
          </vue-scroll>
          <b-list-group
            v-if="!(hasPipeline && hasServer && master && dependent)"
            style="margin-top: 30px"
          >
            <b-list-group-item class="process-head">
              <span>Process</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Server</span>
              <feather-icon
                v-if="hasServer"
                icon="CheckSquareIcon"
                class="CheckIcon"
                size="20"
                color="green"
              />
              <feather-icon
                v-if="!hasServer"
                icon="XSquareIcon"
                size="20"
                color="red"
                class="XIcon"
              />
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Master Variables</span>
              <feather-icon
                v-if="master"
                icon="CheckSquareIcon"
                class="CheckIcon"
                size="20"
                color="green"
              />
              <feather-icon
                v-if="!master"
                icon="XSquareIcon"
                size="20"
                color="red"
                class="XIcon"
              />

            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Dependent Variables</span>
              <feather-icon
                v-if="dependent"
                icon="CheckSquareIcon"
                class="CheckIcon"
                size="20"
                color="green"
              />
              <feather-icon
                v-if="!dependent"
                icon="XSquareIcon"
                size="20"
                color="red"
                class="XIcon"
              />
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Pipeline</span>
              <feather-icon
                v-if="hasPipeline"
                icon="CheckSquareIcon"
                class="CheckIcon"
                size="20"
                color="green"
              />
              <feather-icon
                v-if="!hasPipeline"
                icon="XSquareIcon"
                size="20"
                color="red"
                class="XIcon"
              />
            </b-list-group-item>
          </b-list-group>
          <div style="display:flex; justify-content: space-around; margin-top:20px">
            <b-button
              v-if="ready && !computing"
              variant="success"
              size="sm"
              @click="compute"
            >
              COMPUTE
            </b-button>
            <b-button
              v-if="ready && computing"
              variant="outline-danger"
              size="sm"
              @click="confirm('stop')"
            >
              STOP
            </b-button>
            <b-button
              v-if="ready && computing"
              variant="danger"
              size="sm"
              @click="confirm('abort')"
            >
              ABORT
            </b-button>
          </div>
        </b-card-code>
      </b-col>
      <b-col
        lg="9"
        md="12"
      >
        <b-tabs>
          <b-tab active>
            <template #title>
              <feather-icon icon="ServerIcon" />
              <span>Severs</span>
            </template>
            <b-card-code
              class="submain styled"
              title="Servers"
            >
              <servers
                :servers="servers"
                :computing="computing"
              />
            </b-card-code>
          </b-tab>
          <b-tab :disabled="(!hasServer)">
            <template #title>
              <feather-icon icon="CheckSquareIcon" />
              <span>Master Variables</span>
            </template>
            <b-card-code
              title="Master Variables"
              class="submain styled"
            >
              <b-row>
                <b-col md="12">
                  <block-input
                    v-for="item in masterVariables"
                    :key="item.name"
                    :data="item"
                    :value="masterValues[item.name]"
                    :disabled="computing"
                    :bt-disabled="loadDisabled"
                    :model-options="modelOptions"
                    :server="server"
                    :user="1"
                    @genVariable="generateVariable"
                  />
                </b-col>
              </b-row>
            </b-card-code>

          </b-tab>
          <b-tab :disabled="!(hasServer && master)">
            <template #title>
              <feather-icon icon="MenuIcon" />
              <span>Dependent Variables</span>
            </template>
            <b-card-code
              title="Dependent Variables"
              class="submain styled"
            >
              <b-row>
                <b-col md="12">
                  <block-input
                    v-for="item in dependentVariables"
                    :key="item.name"
                    :data="item"
                    :value="dependentValues[item.name]"
                    :disabled="computing"
                    :model-options="[]"
                    :server="server"
                    :user="1"
                    :is-dependent="true"
                    @genVariable="generateVariable"
                  />
                </b-col>
              </b-row>
            </b-card-code>

          </b-tab>
          <b-tab :disabled="!(hasServer && master && dependent)">
            <template #title>
              <feather-icon icon="GitPullRequestIcon" />
              <span>Pipeline</span>
            </template>
            <b-card-code
              title="Pipeline"
              class="submain styled"
            >
              <pipeline
                :selected="hasPipeline"
                :computing="computing"
              />
            </b-card-code>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="FileTextIcon" />
              <span>Log</span>
            </template>
            <b-card-code
              title="Log"
              class="submain styled"
            >
              <log-view :log="log" />
            </b-card-code>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col
        v-if="1 === 2"
        lg="3"
        md="12"
      >
        <b-card-code
          title="Progress"
          class="progress-card"
          no-body
        >
          <b-badge variant="light-warning badge-status">
            calculating
          </b-badge>ntime="runtime"
          />
          <div
            class="output"
          >
            <div
              v-for="(item, index) in outputs"
              :key="'text'+index"
            > {{ item }}</div>
          </div>
        </b-card-code></b-col>
    </b-row>
    <vue-context ref="menu">
      <li>
        <a href="#">Option 1</a>
      </li>
      <li>
        <a href="#">Option 2</a>
      </li>
    </vue-context>
  </div>
</template>
<script>
import vueScroll from 'vuescroll'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BRow, BCol, BButton, BBadge, BTabs, BTab, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import VueContext from 'vue-context'
import store from '@/store/index'
import axios from 'axios'
import BlockInput from './components/blockInputs.vue'
import servers from './servers.vue'
import pipeline from './pipeline.vue'
import LogView from './Log.vue'
import progressTasks from './components/progressTasks.vue'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BButton,
    BBadge,
    BTabs,
    BTab,
    VueContext,
    BlockInput,
    BListGroup,
    BListGroupItem,
    servers,
    pipeline,
    progressTasks,
    vueScroll,
    LogView,
  },
  data() {
    return {
      servers: [],
      masterVariables: [],
      dependentVariables: [],
      masterValues: {},
      dependentValues: {},
      projectName: '',
      projectOwner: '',
      projectVisibility: '',
      projectDescription: '',
      computing: false,
      taskProgress: 0,
      cpu: 0,
      ram: 0,
      runtime: '00:00:00',
      outputs: [],
      computeDisabled: true,
      nodes: [],
      timer: null,
      dependent: false,
      master: false,
      hasServer: false,
      hasPipeline: false,
      pipeline: [],
      progress: [],
      waitting: false,
      computingIndex: 0,
      firstCharge: true,
      modelOptions: [],
      log: [],
      server: '',
      user: 0,
      loadDisabled: true,
    }
  },
  computed: {
    
    ready() {
      if (this.master === true && this.dependent === true && this.hasServer === true && this.hasPipeline === true) {
        return true
      }
      return false
    },
  },
  watch: {
    server() {
      this.getModels()
    },
  },
  created()
  {
    this.$root.$refs.processing = this;
  },
  async mounted() {
   await this.getModels()
   await this.getData()
   await this.getInputs()
   await this.getStatus()
   await this.getProgress()

  
   
     
    this.timer = setInterval(() => {
       this.getStatus()
     this.getProgress()
     
    }, 500)
  },
  destroyed() {},
  beforeDestroy() {
    clearInterval(this.timer)
  },

  
     
 
  methods: {
    prueba_maite(datas,id)
    {
    
     
        var data = this.progress.filter(a => a.ind == id)
        var index = this.progress.findIndex(obj => obj.ind==id);
        if (index > -1)
        {
          this.progress[index]['task_status']['data'] = JSON.stringify(datas)
        }
        // this.progress.forEach(element => {
        //   if(element.ind == id)
        //   {
        //     element.task_status.data = JSON.stringify(data)
        //   }
          
        // });
    
    //     for (const key of Object.keys(this.progress)) {
    // console.log(key + ":" + this.progress[key])
// }
        // for(var i=0;i< this.progress.length;i++)
        // {
        //   if (this.progress[i]['ind'] == id)
        //   {
        //     console.log("SIIII")
        //   }
        // }
        // if (index > -1)
        // {
        //   console.log(this.progress[index])
        // // this.progress[index]['task_status']['data'] = JSON.stringify(data)
        // }
        
    
     
      
    },
    async getModels() {
      if (this.server !== '') {
        const modelOptions = []
        const json = { task_type: '5.0' }
        const data = JSON.stringify({
          project: this.$route.params.id, user: this.user, json, server: this.server,
        })
        await axios.post(`${url}:${port}/variable-options/`, data, { headers }).then(result => {
          console.log(result.data)
          const { options } = result.data
          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < options.methods.length; index++) {
            const option = options.methods[index]
            modelOptions.push({ value: option, text: option })
          }
          this.modelOptions = modelOptions
        })
      } else {
        this.modelOptions = []
      }
    },
   async getData() {
      const { id } = this.$route.params
      await axios.get(`${url}:${port}/project/${id}`, { headers }).then(presult => {
        const { data, visibility } = presult.data
        if (data.length > 0) {
          const project = data[0]
          const users = visibility
          const uvis = []
          this.projectName = project.name
          this.projectOwner = project.owner
          this.projectDescription = project.description
          store.commit('title', project.name)
          store.commit('icon', 'GridIcon')
          store.commit('isProject', true)
          store.commit('isExperimental', false)
          store.commit('activeSec', 'processing')
          if (users !== undefined) {
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < users.length; index++) {
              const element = users[index]
              uvis.push((`${element.name} ${element.lastname}`).trim())
            }
          }
          this.projectVisibility = uvis.join(', ')
        } else {
          this.$router.push({ name: 'Projects' })
        }
      })
    },
   async getInputs() {
      const { id } = this.$route.params
      const masterVariables = []
      const masterValues = {}
      const dependentVariables = []
      const dependentValues = {}
      await axios.get(`${url}:${port}/variables/${id}`, { headers }).then(result => {
        const { data } = result.data
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          if (element.auto === 0 && element.visible === 1) {
            element.original_name = element.name
            const name = (element.name === 'cores') ? 'number_of_cpus' : element.name
            element.name = name
            masterVariables.push(element)
            masterValues[name] = element.value
          } else if (element.auto === 1 && element.visible === 1) {
            element.original_name = element.name
            dependentVariables.push(element)
            dependentValues[element.name] = element.value
          }
        }
        this.masterVariables = masterVariables
        this.dependentVariables = dependentVariables
        this.masterValues = masterValues
        this.dependentValues = dependentValues
      })
    },
    generateVariable(data) {
      if (data.input.type === 0 && data.input.visible === 1) {
        this.masterVariables[data.input.name] = data.value
      } else if (data.input.auto === 1 && data.input.visible === 1) {
        this.dependentValues[data.input.name] = data.value
        console.log('generateVariable', data.input.name, data.value)
        this.saveVariable(data.input.name, data.value)
      }
    },
    saveVariable(input, value) {
      const category = 'processing'
      const data = JSON.stringify({ project: this.$route.params.id, value, category })
      console.log('saveVariable', input, value)
      axios.put(`${url}:${port}/project_variable/${input}`, data, { headers }).then(async result => {
        console.log(result)
      })
    },
    getServerStatus(result, id)
    {

       for(var i=0;i<this.servers.length;i++)
       {
         if(this.servers[i]['id'] == id)
         {
           this.servers[i]['data'] = result
         }
       }
      
    },
    async getStatus() {
      const { id } = this.$route.params
      await axios.get(`${url}:${port}/project_status/${id}`, { headers }).then(result => {
        const {
          dependent, master, hasServer, hasPipeline, status, experimental,
        } = result.data.data
        console.log("RESULT", result)
        const { log } = result.data
        this.log = log
        this.master = master
        this.dependent = dependent
        this.hasServer = hasServer
        this.server = result.data.data.server_id
        this.hasPipeline = hasPipeline
        this.servers = result.data.servers.servers
        this.pipeline = result.data.data.pipeline
        this.loadDisabled = !experimental
        if (this.firstCharge === true) {
          if (status === 1) {
            this.computing = true
          } else {
            this.computing = false
          }
          this.firstCharge = false
        }
      })
    },
    async getProgress() {
      if (this.master && this.dependent && this.hasPipeline && this.hasServer) {
        const { id } = this.$route.params
        await axios.get(`${url}:${port}/project_progress/${id}`, { headers }).then(result => {
          if (result.data.progress !== undefined) {
            console.log("PROGRESS", result.data.progress)
            this.progress = result.data.progress
          }
        })
      }
    },
    compute() {
      this.computing = true
      this.computingIndex += 1
      const { id } = this.$route.params
      const data = { pipeline: JSON.parse(this.pipeline), user_id: 1 }
      console.log(data)
      axios.post(`${url}:${port}/compute/${id}`, JSON.stringify(data), { headers })
    },
    stop() {
      this.computing = false
      this.computingIndex += 1
      const { id } = this.$route.params
      axios.post(`${url}:${port}/stop-compute/${id}`, JSON.stringify({}), { headers })
    },
    abort() {
      this.computing = false
      this.computingIndex += 1
      const { id } = this.$route.params
      axios.post(`${url}:${port}/abort-compute/${id}`, JSON.stringify({}), { headers })
    },
    confirm(type) {
      let confirmBtn = 'Yes, stop it!'
      let confirmTitle = 'Stopped!'
      let confirmText = 'The process has been stopped.'
      if (type === 'abort') {
        confirmBtn = 'Yes, abort process!'
        confirmText = 'The process has been aborted.'
        confirmTitle = 'Aborted!'
      }
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmBtn,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          if (type === 'abort') {
            this.abort()
          } else {
            this.stop()
          }
          this.$swal({
            icon: 'success',
            title: confirmTitle,
            text: confirmText,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
<style>
.process-head{
  background:#008380;
  color: #fff;
  font-weight: 600;
}
.list-group .list-group-item.process-head:hover{
  background:#008380;
  color: #fff;
  font-weight: 600;
}
.checkIcon{
  stroke: green !important;
  font-size: 30px ;
}
#chart{
  height:580px!important;
}
.btn-algorithm {
opacity: 0.5;
}
.btn-compute, .badge-status{
    position: absolute;
    right: 20px;
    top: 20px;
}
.progress-card .card-header .card-title{
    color: #5e58733f!important;
}
.output{
        margin: 20px 10px 30px;
    height: 250px;
    border-radius: 10px;
    background-color: #3B3D48;
    border: none;
    padding: 20px;
    font-family: monospace;
    color: #fff;
    font-size: initial;
}
#position {
     display: none !important;
}
#svg {
    background-image: unset
}
#svg text{
   font-size: 10px!important;
}
.connectorText{
  font-size: 10px!important;
}
</style>
<style lang="css">
.card{
 border-radius: 10px!important;
}
.styled .card-header{
  background-color: #028380;
  margin-bottom:20px;
  border-radius: 10px 10px 0px 0px !important;
}
.styled .card-header h4{
  color: #fff;
}
.main .card-header{
  background-color: #028380;
}
.main .card-header h4{
  color: #fff;
}
.submain .card-header{
  background-color: #0283807d;
}
.submain .card-header h4{
  color: #000;
}
span.tag {
    background-color: #0283807d;
    border-radius: 5px;
    padding: 2px 10px;
    margin-right: 5px;
    color: white;
    font-weight: 600;
}

span.tag svg{
    margin-right: 5px;
}
p.list {
    margin-bottom: 10px;
}
</style>
